import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import {
  ListingDetailsLayout,
  ListingDetailsLayoutV2,
} from '@/buyer-portal/components/features/listing/ListingDetailsLayout'
import { FeatureFlags } from '@/helpers/featureFlags'
import { type ListingDetails } from '@/queries/listingDetailsQuery'

export const ListingDetailsPageLoaded = ({
  listing,
  initialBidAmount,
  referral_url,
}: {
  listing: ListingDetails
  initialBidAmount: string | undefined
  referral_url: string
}) => {
  const enableLdpRedesign = useFlag(FeatureFlags.ENABLE_LDP_REDESIGN)

  return enableLdpRedesign ? (
    <ListingDetailsLayoutV2
      listing={listing}
      referralUrl={referral_url}
      initialBidAmount={initialBidAmount}
    />
  ) : (
    <ListingDetailsLayout
      listing={listing}
      referralUrl={referral_url}
      initialBidAmount={initialBidAmount}
    />
  )
}
